import React, { useState } from "react";

const FAQSection = () => {
  const [activeTab, setActiveTab] = useState(null);

  const faqs = [
    {
      id: 1,
      question: "How is this different from applying on my own?",
      answer:
        "Lovapex combines customized applications, recruiter follow-ups, ATS resume optimization, visa-aware targeting, and progress tracking into one managed process.",
    },
    {
      id: 2,
      question: "Do you guarantee I will get a job?",
      answer:
        "No service can control the market or interview performance. Lovapex focuses on running a structured, high-quality process that increases the chance of interviews.",
    },
    {
      id: 3,
      question: "How quickly will I see results?",
      answer:
        "The expected ramp is early application activity in weeks 1-2, possible interviews in weeks 2-4, and offer timing that depends on role fit and market conditions.",
    },
    {
      id: 4,
      question: "I am on OPT or H-1B. Can you help?",
      answer:
        "The service is designed with international professionals in mind, including visa-sponsor targeting, positioning, and deadline-sensitive outreach.",
    },
    {
      id: 5,
      question: "I am currently employed. Is this discreet?",
      answer:
        "Yes. The process can avoid current employers, avoid public Open to Work signals, keep tracking private, and support flexible interview scheduling.",
    },
  ];

  return (
    <section className="section">
      <div className="container">
        <div className="section-heading">
          <p className="eyebrow">Quick Help</p>
          <h2>Frequently Asked Questions</h2>
        </div>

        <div className="faq-list">
          {faqs.map((faq) => (
            <div
              key={faq.id}
              className={`faq-item ${activeTab === faq.id ? "open" : ""}`}
            >
              <button
                type="button"
                onClick={() =>
                  setActiveTab(activeTab === faq.id ? null : faq.id)
                }
              >
                <span>{faq.question}</span>
                <span>{activeTab === faq.id ? "Close" : "Open"}</span>
              </button>

              {activeTab === faq.id && <p>{faq.answer}</p>}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
